 
<template>
  <v-card>
    <v-card-title> {{ $t("Kysymykset & vastaukset") }} </v-card-title>
    <!-- actions -->

    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-spacer></v-spacer>

      <div class="d-flex align-center flex-wrap">
        <v-btn color="primary" class="mb-4" :to="{ name: 'admin-faq-form' }">
          <span>{{ $t("Uusi kysymys") }}</span>
        </v-btn>
      </div>
    </v-card-text>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center" style="width: 60px"></th>
            <th class="text-uppercase">
              {{ $t("Kysymys") }}
            </th>
            <th class="text-uppercase">
              {{ $t("Julkaistu") }}
            </th>
          </tr>
        </thead>
        <draggable
          v-model="faqs"
          tag="tbody"
          handle=".handle"
          ghost-class="ghost"
          @end="sort(faqs)"
        >
          <tr v-for="faq in faqs" :key="faq.id">
            <td class="text-center">
              <v-icon class="handle">
                {{ icons.mdiCursorMove }}
              </v-icon>
            </td>
            <td>
              <router-link
                :to="{ name: 'admin-faq-form', params: { id: faq.id } }"
              >
                {{ faq.question }}
              </router-link>
            </td>
            <td>
              <div>
                <v-icon v-if="faq.published" size="24" color="success"
                  >{{ icons.mdiCheckboxMarkedCircle }}
                </v-icon>
                <v-icon v-else size="24" color="error"
                  >{{ icons.mdiCloseCircle }}
                </v-icon>
              </div>
            </td>
          </tr>
        </draggable>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import adminApi from "@/api/admin";
import {
  mdiCheckboxMarkedCircle,
  mdiCloseCircle,
  mdiPlus,
  mdiCursorMove,
} from "@mdi/js";
import { useTranslations } from "@core/libs/i18n";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  setup() {
    const faqs = ref([]);
    const loading = ref(false);
    const { t } = useTranslations();

    // fetch data
    const fetchFaqs = async () => {
      loading.value = true;

      const response = await adminApi.getFaqList();
      faqs.value = response.data;

      loading.value = false;
    };

    // UnRegister on leave
    onMounted(() => {
      fetchFaqs();
    });

    const sort = async () => {
      loading.value = true;

      const sortedIds = faqs.value.map((a) => a.id);
      await adminApi.sortFaq(sortedIds);

      fetchFaqs();
    };

    return {
      faqs,
      loading,
      sort,

      icons: {
        mdiCheckboxMarkedCircle,
        mdiCloseCircle,
        mdiPlus,
        mdiCursorMove,
      },
    };
  },
};
</script>